module.exports = __webpack_public_path__ + "img/resetButton.d85fe962.svg";